var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    fill: "none",
    style: {
      color: "#fff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13 6c0-3.31-2.69-6-6-6S1 2.69 1 6c0 4.5 6 11 6 11s6-6.5 6-11M5 6c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 1 1-4 0M0 18v2h14v-2z"
  })));
};
export { SvgPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIHN0eWxlPSJjb2xvcjogd2hpdGUiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDZDMTMgMi42OSAxMC4zMSAwIDcgMEMzLjY5IDAgMSAyLjY5IDEgNkMxIDEwLjUgNyAxNyA3IDE3QzcgMTcgMTMgMTAuNSAxMyA2Wk01IDZDNSA0LjkgNS45IDQgNyA0QzguMSA0IDkgNC45IDkgNkM5IDcuMSA4LjExIDggNyA4QzUuOSA4IDUgNy4xIDUgNlpNMCAxOFYyMEgxNFYxOEgwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";